var DealsPaginationEvents, DealsPaginationEventsHelper, PaginatedDealsBuilder, UpdateAppURLHelper, fetchAndRenderDeals, sendPaginationEvent, updateURLAndFetch;

UpdateAppURLHelper = require('../../../shared/frontend/helpers/app_url');

PaginatedDealsBuilder = require('./paginated_deals_builder');

DealsPaginationEvents = require('../pagination_events');

module.exports = DealsPaginationEventsHelper = {
  updatePageByHref: function(url, shouldScroll) {
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToPreviousPage: function(shouldScroll) {
    var qs, queryString, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (!(qs.page > 1)) {
      return;
    }
    qs.page--;
    if (qs.page <= 1) {
      delete qs.page;
    }
    queryString = !_.isEmpty(qs) ? "?" + ($.param(qs)) : "";
    url = "" + window.location.pathname + queryString;
    return updateURLAndFetch(url, shouldScroll);
  },
  updateToNextPage: function(shouldScroll) {
    var qs, url;
    if (shouldScroll == null) {
      shouldScroll = true;
    }
    qs = Groupon.Utils.unparam();
    if (qs.page != null) {
      qs.page++;
    } else {
      qs.page = 2;
    }
    if (qs.page > Groupon.pagination.totalPages) {
      return;
    }
    url = window.location.pathname + "?" + ($.param(qs));
    return updateURLAndFetch(url, shouldScroll);
  },
  popStateHandler: function(currentSearchPage) {
    var popStatePage, ref;
    popStatePage = (ref = Groupon.Utils.unparam().page) != null ? ref : 1;
    if (currentSearchPage !== popStatePage) {
      return fetchAndRenderDeals();
    }
  }
};

updateURLAndFetch = function(url, shouldScroll) {
  UpdateAppURLHelper(url, {
    pushState: true
  });
  if (shouldScroll) {
    $(document).scrollTop(0);
  }
  return fetchAndRenderDeals();
};

fetchAndRenderDeals = function() {
  var paginatedBuilder;
  paginatedBuilder = new PaginatedDealsBuilder;
  Groupon.browseApp.renderContent({
    paginatedDealsBuilder: paginatedBuilder
  });
  return paginatedBuilder.on("fetchSuccess", function(search) {
    return sendPaginationEvent(search);
  });
};

sendPaginationEvent = function(dealSearch) {
  return DealsPaginationEvents.trigger("newPage", dealSearch.page);
};

//# sourceMappingURL=data:application/json;base64,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
